var DealsPaginationEvents, DealsPaginationEventsHelper, PaginatedDealsBuilder, UpdateAppURLHelper, fetchAndRenderDeals, sendPaginationEvent, updateURLAndFetch;

UpdateAppURLHelper = require('../../../shared/frontend/helpers/app_url');

PaginatedDealsBuilder = require('./paginated_deals_builder');

DealsPaginationEvents = require('../pagination_events');

module.exports = DealsPaginationEventsHelper = {
  updatePageByHref: function(url, shouldScroll) {
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToPreviousPage: function(shouldScroll) {
    var qs, queryString, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (!(qs.page > 1)) {
      return;
    }
    qs.page--;
    if (qs.page <= 1) {
      delete qs.page;
    }
    queryString = !_.isEmpty(qs) ? "?" + ($.param(qs)) : "";
    url = "" + window.location.pathname + queryString;
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToNextPage: function(shouldScroll) {
    var qs, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (qs.page != null) {
      qs.page++;
    } else {
      qs.page = 2;
    }
    if (qs.page > Groupon.pagination.totalPages) {
      return;
    }
    url = window.location.pathname + "?" + ($.param(qs));
    return updateURLAndFetch(url, shouldScroll);
  },
  popStateHandler: function(currentSearchPage) {
    var popStatePage, ref;
    popStatePage = (ref = Groupon.Utils.unparam().page) != null ? ref : 1;
    if (currentSearchPage !== popStatePage) {
      return fetchAndRenderDeals();
    }
  }
};

updateURLAndFetch = function(url, shouldScroll) {
  UpdateAppURLHelper(url, {
    pushState: true
  });
  if (shouldScroll) {
    $(document).scrollTop(0);
  }
  return fetchAndRenderDeals();
};

fetchAndRenderDeals = function() {
  var paginatedBuilder;
  paginatedBuilder = new PaginatedDealsBuilder;
  Groupon.browseApp.renderContent({
    paginatedDealsBuilder: paginatedBuilder
  });
  return paginatedBuilder.on("fetchSuccess", function(search) {
    return sendPaginationEvent(search);
  });
};

sendPaginationEvent = function(dealSearch) {
  return DealsPaginationEvents.trigger("newPage", dealSearch.page);
};

//# sourceMappingURL=data:application/json;base64,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
